import { generateNativeUUID } from "../../utils";
import { cookie } from "../storage";
var generateAnonymousId = function (key) {
    var storedAnonymousId = cookie().get(key);
    if (storedAnonymousId && typeof storedAnonymousId === "string")
        return storedAnonymousId;
    var newAnonymousId = generateNativeUUID();
    cookie().set(key, newAnonymousId, {
        maxAge: Date.now() + 1000 * 60 * 60 * 24 * 365, // 1 year
        domain: getCookieDomain(),
        path: "/",
    });
    return newAnonymousId;
};
function getCookieDomain(hostname) {
    if (hostname === void 0) { hostname = window.location.hostname; }
    // Special cases
    if (hostname.includes("localhost") ||
        /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
        // Localhost or IP address
        return "";
    }
    var parts = hostname.split(".");
    if (parts.includes("www"))
        parts.splice(parts.indexOf("www"), 1);
    return ".".concat(parts.join("."));
}
export { generateAnonymousId, getCookieDomain };
//# sourceMappingURL=utils.js.map